import { testimonialService } from '@/services/testimonial.service';
import { useQuery } from '@tanstack/react-query';


export const useGetAllTestimonials = (pageNumber: number) => {
    const { data, isLoading, isError, error, refetch, isPending } = useQuery({
        queryKey: ['testimonial', pageNumber],
        queryFn: () => testimonialService.getAllTestimonials(pageNumber),
    });
    return {
        testimonials: data?.data ?? [],
        totalPages: data?.pageCount,
        isLoading,
        isError,
        error,
        refetch,
        isPending,
    };
};
